"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = slugify;
exports.localizedSlug = localizedSlug;
// Zod içermez: web istemci paketine şemaları taşımadan "@endeks/shared/slug" ile import edilir.
const TR_MAP = { ç: "c", ğ: "g", ı: "i", ö: "o", ş: "s", ü: "u" };
// Başlıktan URL slug'ı üretir. "tr" yerel küçültmesi "İ" → "i" dönüşümünü doğru yapar
// (düz toLowerCase "i̇" üretip "i-stanbul" gibi bozuk slug'a yol açıyordu).
function slugify(text) {
    return text
        .toLocaleLowerCase("tr")
        .replace(/[çğıöşü]/g, (ch) => TR_MAP[ch] ?? ch)
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        // Kesme işareti ayraç sayılmaz: "İstanbul'da" → "istanbulda", "istanbul-da" değil.
        .replace(/['’‘`´]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}
// Kaydın verilen dildeki slug'ı. slugEn boşsa EN'de de TR slug kullanılır.
function localizedSlug(entity, locale) {
    return locale === "en" && entity.slugEn ? entity.slugEn : entity.slug;
}
//# sourceMappingURL=slug.js.map